import React from 'react';
import { AlertDialogProps } from '../components/alert-dialog/AlertDialog';

export const AlertDialogContext = React.createContext<{
  alert?: (props: AlertDialogProps) => Promise<boolean>;
}>({});
